module.exports = __webpack_public_path__ + "img/bottomList2_active.026763ab.svg";